// extracted by mini-css-extract-plugin
module.exports = {"infoTable":"InfoTable_infoTable__2r3__"};